import { StyledFormControl, StyledFormLabel } from 'components/AdminConsole/commonUI/styles'
import { Workflow } from 'lucide-react'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { FormErrorMessage, Text } from '@chakra-ui/core'
import useLocaleText from 'components/useLocaleText'
import { TextInput } from 'components/ui/Input'

export const CampaignTitle = () => {
  const { errors, control } = useFormContext()

  const competition_title = useLocaleText('competition_title', true)
  const error_competition_title = useLocaleText('error_competition_title', true)
  const competition_title_placeholder = useLocaleText('competition_title_placeholder', true)

  return (
    <StyledFormControl isInvalid={!!errors.products_cluster_data?.title}>
      <StyledFormLabel required>
        <Workflow size={18} strokeWidth={2.5} />
        <Text>{competition_title}</Text>
      </StyledFormLabel>
      <Controller
        name="products_cluster_data.title"
        control={control}
        defaultValue=""
        rules={{
          required: error_competition_title,
          validate: (value) => {
            return value?.trim() !== '' || error_competition_title
          },
        }}
        as={TextInput}
        maxLength={100}
        elementHeight="40px"
        placeholder={competition_title_placeholder}
        boxShadow="none"
        borderRadius="5px"
        _focus={{
          border: '1px solid black',
        }}
      />

      <FormErrorMessage style={{ columnGap: '10px' }}>
        {errors.products_cluster_data?.title && errors.products_cluster_data?.title.message}
      </FormErrorMessage>
    </StyledFormControl>
  )
}
